
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 126 47"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFFFFE","fill-rule":"evenodd","d":"M108.691 32.471c-2.942 0-5.709.753-8.119 2.074-3.933-5.935-10.67-9.851-18.324-9.851-1.757 0-3.464.212-5.102.601C75.34 11.032 63.17 0 48.416 0c-16 0-28.972 12.97-28.972 28.971l.002.087a17.913 17.913 0 00-1.752-.087C7.922 28.971 0 36.893 0 46.665h125.387c-1.303-8.047-8.28-14.194-16.696-14.194z"}})])
          )
        }
      }
    